"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var OnceTask_1 = require("./OnceTask");

var TaskStatus_1 = require("./TaskStatus");
/*
 * [[BaseTask]] provides common utilities for task implementations.
 */


var BaseTask = /*#__PURE__*/function () {
  function BaseTask(logger) {
    _classCallCheck(this, BaseTask);

    this.logger = logger;
    this.taskName = 'BaseTask';
    this.parentTask = null;
    this.status = TaskStatus_1.default.IDLE;
    this.run = this.baseRun.bind(this, this.run);
    this.cancel = this.baseCancel.bind(this, this.cancel);
  }

  _createClass(BaseTask, [{
    key: "once",
    value: function once() {
      for (var _len = arguments.length, dependencies = new Array(_len), _key = 0; _key < _len; _key++) {
        dependencies[_key] = arguments[_key];
      }

      return new OnceTask_1.default(this.logger, this, dependencies);
    }
  }, {
    key: "cancel",
    value: function cancel() {}
  }, {
    key: "name",
    value: function name() {
      return this.parentTask ? "".concat(this.parentTask.name(), "/").concat(this.taskName) : this.taskName;
    }
  }, {
    key: "setParent",
    value: function setParent(parentTask) {
      this.parentTask = parentTask;
    }
  }, {
    key: "getStatus",
    value: function getStatus() {
      return this.status;
    }
  }, {
    key: "logAndThrow",
    value: function logAndThrow(message) {
      this.logger.info(message);
      throw new Error(message);
    }
  }, {
    key: "baseRun",
    value: function baseRun(originalRun) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var startTime;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                startTime = Date.now();
                this.logger.info("running task ".concat(this.name()));

                switch (this.status) {
                  case TaskStatus_1.default.RUNNING:
                    this.logAndThrow("".concat(this.name(), " is already running"));

                  case TaskStatus_1.default.CANCELED:
                    this.logAndThrow("".concat(this.name(), " was canceled before running"));

                  case TaskStatus_1.default.FINISHED:
                    this.logAndThrow("".concat(this.name(), " was already finished"));
                }

                this.status = TaskStatus_1.default.RUNNING;
                _context.next = 7;
                return originalRun.call(this);

              case 7:
                this.logger.info("".concat(this.name(), " took ").concat(Math.round(Date.now() - startTime), " ms"));
                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                throw _context.t0;

              case 13:
                _context.prev = 13;

                if (this.status !== TaskStatus_1.default.CANCELED) {
                  this.status = TaskStatus_1.default.FINISHED;
                }

                return _context.finish(13);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10, 13, 16]]);
      }));
    }
  }, {
    key: "baseCancel",
    value: function baseCancel(originalCancel) {
      if (this.status === TaskStatus_1.default.CANCELED || this.status === TaskStatus_1.default.FINISHED) {
        this.logger.info("Not canceling ".concat(this.name(), ": state is ").concat(this.status));
        return;
      }

      this.logger.info("canceling task ".concat(this.name()));
      this.status = TaskStatus_1.default.CANCELED;
      originalCancel.call(this);
    }
  }]);

  return BaseTask;
}();

exports.default = BaseTask;